import React, { PropsWithChildren } from 'react'
import Bugsnag from '@bugsnag/js'

export const ErrorBoundary =
    location.hostname !== 'localhost' ? Bugsnag.getPlugin('react').createErrorBoundary(React) : ({ children }: PropsWithChildren) => children
